import { store } from '../store/store';
import { clearAuthData } from '../store/slice/authSlice';
import toast from 'react-hot-toast';

let inactivityTimer = null;
let warningTimer = null;

const ONE_MINUTE = 60 * 1000;
const ONE_HOUR = 60 * ONE_MINUTE;
const WARNING_TIME = 5 * ONE_MINUTE; 

const resetTimers = () => {
  if (inactivityTimer) clearTimeout(inactivityTimer);
  if (warningTimer) clearTimeout(warningTimer);

  warningTimer = setTimeout(() => {
    toast(
      "⚠️ You’ll be logged out in 5 minutes due to inactivity",
      { duration: 5000 }
    );
  }, ONE_HOUR - WARNING_TIME);

  inactivityTimer = setTimeout(() => {
    store.dispatch(clearAuthData());
    toast.error('Session expired due to inactivity. Please login again.');
    window.location.href = '/login';
  }, ONE_HOUR);
};

export const startInactivityWatcher = () => {
  const events = ['mousemove', 'keydown', 'click', 'scroll'];

  events.forEach(event =>
    window.addEventListener(event, resetTimers)
  );

  resetTimers(); 
};

export const stopInactivityWatcher = () => {
  if (inactivityTimer) clearTimeout(inactivityTimer);
  if (warningTimer) clearTimeout(warningTimer);

  const events = ['mousemove', 'keydown', 'click', 'scroll'];
  events.forEach(event =>
    window.removeEventListener(event, resetTimers)
  );
};
